<template>
  <div class="page page__list">
    <search-bar @search="onSearch" name="mn_name" placeholder="输入单据名称进行查找" ref="searchBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="gotoView(item)"
      >
        <div class="weui-cell__bd">
          <p>{{item.mn_name}}</p>
        </div>
        <div class="weui-cell__ft"></div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}个</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/commons/number/list",
      params: {
        mode: "MAIN",
        number: 1,
        size: 20
      }
    };
  },
  methods: {
    gotoView(item) {
      this.$router.push({
        name: "SysCodeRuleEdit",
        params: {
          initData: Object.assign({}, item),
        },
      });
    },
  },
};
</script>